import { InjectionToken } from '@angular/core';
import { FanManagementConfigModel } from './shared/api';

export const BASE_FM_CONFIG = new InjectionToken<FanManagementConfigModel>('Fanmanagement configuration model');
